import React from 'react';
import { AlertCircle } from 'lucide-react';
export function CostOfInaction() {
  return <section className="py-20 bg-white px-6 lg:px-8" data-id="element-39">
      <div className="max-w-4xl mx-auto" data-id="element-40">
        <div className="text-center mb-12" data-id="element-41">
          <h2 className="text-3xl md:text-4xl font-extrabold text-brand-navy mb-4" data-id="element-42">
            ¿Cuánto te cuesta NO tener un sistema?
          </h2>
        </div>

        <div className="bg-red-50 rounded-3xl p-8 border border-red-100 shadow-soft" data-id="element-43">
          <div className="flex items-center gap-3 mb-6 text-red-600 font-bold text-xl" data-id="element-44">
            <AlertCircle className="w-6 h-6" data-id="element-45" />
            El costo real de improvisar
          </div>

          <div className="space-y-4" data-id="element-46">
            <div className="flex justify-between items-center border-b border-red-100 pb-4" data-id="element-47">
              <span className="text-brand-navy font-medium" data-id="element-48">
                Meses sin tu primera venta
              </span>
              <span className="text-red-500 font-bold" data-id="element-49">
                = Ingresos perdidos
              </span>
            </div>
            <div className="flex justify-between items-center border-b border-red-100 pb-4" data-id="element-50">
              <span className="text-brand-navy font-medium" data-id="element-51">
                Clientes que dudan por tu inexperiencia
              </span>
              <span className="text-red-500 font-bold" data-id="element-52">
                = Tasaciones perdidas
              </span>
            </div>
            <div className="flex justify-between items-center border-b border-red-100 pb-4" data-id="element-53">
              <span className="text-brand-navy font-medium" data-id="element-54">
                Falta de seguimiento en WhatsApp
              </span>
              <span className="text-red-500 font-bold" data-id="element-55">
                = Comisiones que se lleva otro
              </span>
            </div>
            <div className="flex justify-between items-center pt-2" data-id="element-56">
              <span className="text-brand-navy font-bold" data-id="element-57">
                Inversión en el Megapack
              </span>
              <span className="text-brand-green font-bold text-xl" data-id="element-58">
                Se paga con el 10% de tu primera comisión
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}